import {YesNoFormValue, type YesNoItemWithCommentFormValues} from '../types'

export type YesNoItemWithComment = {
  value: boolean
  comment?: string
}

export const mapYesNoItemToFormItem = (
  item: YesNoItemWithComment
): YesNoItemWithCommentFormValues => ({
  value: item.value ? YesNoFormValue.YES : YesNoFormValue.NO,
  comment: item.comment
})

export const mapYesNoFormValuesToItem = (
  item: YesNoItemWithCommentFormValues
): YesNoItemWithComment => ({
  value: item.value === YesNoFormValue.YES,
  comment: item.comment
})

export const mapYesNoFormValueToBoolean = (value: YesNoFormValue): boolean =>
  value === YesNoFormValue.YES

export const mapBooleanToYesNoFormValue = (value: boolean): YesNoFormValue =>
  value ? YesNoFormValue.YES : YesNoFormValue.NO
